module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "theHeader",
    staticClass: "o-header",
    style: ({
      width: _vm.theCurrentHeaderWidth,
      position: _vm.theCurrentHeaderPosition
    })
  }, [_c('div', {
    staticClass: "o-menu__icon-mob",
    on: {
      "click": _vm.updateMobileMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin flex-state-buttons u-full-width u-flex-direction-row u-r-flex-start"
  }, [_c('div', {
    staticClass: "a-logo-image"
  }, [_c('h1', [_c('svg', {
    attrs: {
      "viewBox": "0 0 400 53.8"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin o-header__right"
  }, [_c('div', {
    staticClass: "o-header__button-container"
  }, [(_vm.saveButton) ? _c('div', {
    class: [_vm.saving() ? 'a-loader--save-claim' : '']
  }) : _vm._e(), _vm._v(" "), (_vm.saveButton && !_vm.saving()) ? _c('button', {
    staticClass: "a-button a-button--header-button",
    attrs: {
      "disabled": _vm.current && !_vm.current.valid
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("Save Claim")]) : _vm._e(), _vm._v(" "), (_vm.loadButton) ? _c('button', {
    staticClass: "a-button a-button--header-button u-margin-left-10",
    on: {
      "click": _vm.force
    }
  }, [_vm._v("Load Claim")]) : _vm._e(), _vm._v(" "), _c('create-a-new-claim')], 1), _vm._v(" "), _c('div', {
    staticClass: "o-header__bc-logo u-r-margin-left-20"
  }, [_c('span', [_vm._v("created by:")]), _vm._v(" "), _c('svg', {
    attrs: {
      "viewBox": "0 0 185 52"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#bc-logo"
    }
  })])])])]), _vm._v(" "), _c('div', {
    class: {
      'o-header__line': _vm.setBorder
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52186acf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1689
// module chunks = 0